import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CardView, rem } from 'design-system';
import { View, Text as RNText } from 'react-native';
import Animated, { Easing, cancelAnimation, runOnJS, useAnimatedStyle, useSharedValue, withDelay, withTiming, } from 'react-native-reanimated';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import ShimmeringStars from '../../../../design-system/ShimmeringStars';
const reviews = [
    {
        title: 'By far the best budgeting app!',
        description: 'Emma just makes budgeting and tracking so much easier. I was looking to have a better understanding of my spending.',
    },
    {
        title: 'Love it!',
        description: 'I am really enjoying this app. This app puts a large portion of information in one place in a user friendly format.',
    },
    {
        title: 'Couldn\u2019t recommend more',
        description: 'app has amazing insights. have been using for 3 years, i\u2019ve tested everything out there and nothing beats this.',
    },
    {
        title: 'Emma helped me better my life',
        description: 'The app is so well presented and intuitive it really helped me dial down into my finances and get a better understanding of my habits.',
    },
    {
        title: 'Great for budgeting',
        description: 'Helped me get a real handle on my budget all in one place. Subscription tracker is particular is very useful and helped me.',
    },
];
const allReviews = [...reviews, ...reviews];
const HOLD_DURATION = 3000;
const SNAP_DURATION = 800;
const ScrollingReviews = ({ withShimmeringStars = true, }) => {
    const styles = useStyles(styleSet);
    const [containerWidth, setContainerWidth] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);
    const [shimmerTick, setShimmerTick] = useState(0);
    const translateX = useSharedValue(0);
    const step = useRef(0);
    const scheduleNextRef = useRef(undefined);
    const onSnapDone = useCallback(() => {
        if (step.current >= reviews.length) {
            translateX.value = 0;
            step.current = 0;
        }
        setActiveIndex(step.current);
        setShimmerTick((prev) => prev + 1);
        scheduleNextRef.current?.();
    }, [translateX]);
    const onLayout = useCallback((e) => {
        setContainerWidth(e.nativeEvent.layout.width);
    }, []);
    useEffect(() => {
        let active = true;
        if (containerWidth > 0) {
            const scheduleNext = () => {
                if (!active)
                    return;
                step.current += 1;
                translateX.value = withDelay(HOLD_DURATION, withTiming(-step.current * containerWidth, {
                    duration: SNAP_DURATION,
                    easing: Easing.bezier(0.65, 0.12, 0.73, 1.01),
                }, (finished) => {
                    if (finished) {
                        runOnJS(onSnapDone)();
                    }
                }));
            };
            scheduleNextRef.current = scheduleNext;
            step.current = 0;
            translateX.value = 0;
            setActiveIndex(0);
            scheduleNext();
        }
        return () => {
            active = false;
            cancelAnimation(translateX);
        };
    }, [containerWidth, translateX, onSnapDone]);
    const rowStyle = useAnimatedStyle(() => ({
        transform: [{ translateX: translateX.value }],
    }));
    const firstReview = reviews[0];
    return (<View style={styles.container} onLayout={onLayout}>
      {containerWidth > 0 ? (<Animated.View style={[styles.row, rowStyle]}>
          {allReviews.map((review, index) => (<View key={index} style={{ width: containerWidth }}>
              <CardView withPadding style={styles.review}>
                <RNText style={styles.reviewTitle}>{review.title}</RNText>
                <ShimmeringStars key={index === activeIndex
                    ? `active-${shimmerTick}`
                    : `idle-${index}`} animate={index === activeIndex && withShimmeringStars} repeatCount={1}/>
                <RNText style={styles.reviewText}>{review.description}</RNText>
              </CardView>
            </View>))}
        </Animated.View>) : (<CardView withPadding style={styles.review}>
          <RNText style={styles.reviewTitle}>{firstReview.title}</RNText>
          <ShimmeringStars animate={withShimmeringStars} repeatCount={1}/>
          <RNText style={styles.reviewText}>{firstReview.description}</RNText>
        </CardView>)}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        overflow: 'hidden',
    },
    row: {
        flexDirection: 'row',
    },
    review: {
        marginTop: rem(32),
    },
    reviewTitle: {
        fontSize: rem(18),
        fontWeight: 600,
        fontFamily: 'System',
        lineHeight: rem(21),
        color: colors.text.primary,
    },
    reviewText: {
        fontSize: rem(14),
        fontWeight: 400,
        fontFamily: 'System',
        lineHeight: rem(18),
        color: colors.text.secondary,
    },
}));
export default ScrollingReviews;
